export default __webpack_public_path__ + "static/media/B76.ab8737e8.png";